import { isAxiosError } from 'axios';

import { apiClient } from '@/services/api';
import { HOAChecklistResponse } from '@/types/HOA';
import { logger } from '@/utils/logger/loggerInstance';

export const fetchHOAChecklist = async (
  propertyId: string,
): Promise<HOAChecklistResponse | null> => {
  const url = `/properties/${propertyId}/hoa-checklist`;
  logger.debug(`GET ${url}`);
  try {
    const response = await apiClient.get<HOAChecklistResponse>(url);
    return response.data;
  } catch (err) {
    // Only return null for the specific "not HOA-governed" 404.
    // A 404 with code item_not_found (property missing) or any other error
    // should surface so the UI can show an appropriate error state.
    if (
      isAxiosError(err) &&
      err.response?.status === 404 &&
      err.response.data?.code === 'not_hoa_governed'
    ) {
      return null;
    }
    throw err;
  }
};
